export default "__VITE_ASSET__C8UJIiZE__"